import { useEffect, useState } from "react"
import { useAppDependencies } from "src/context/AppContext"
import StateConstants from "src/states/StateContstants"
import { fireFireworks } from "src/utils/celebrate"
import { SubscriptionReturnStatus } from "./Subscription"
import "./SubscriptionReturnNotice.css"

const MESSAGES: Record<Exclude<SubscriptionReturnStatus, null>, string> = {
    activating: "Unlocking…",
    activated: "You're subscribed. Every figure is unlocked.",
    delayed: "Payment received. Refresh in a moment to see every figure.",
}

export default function SubscriptionReturnNotice() {
    const { stateHandler } = useAppDependencies()
    const [status, setStatus] = useState<SubscriptionReturnStatus>(
        stateHandler.get(StateConstants.SUBSCRIPTION_RETURN_STATUS) ?? null
    )

    useEffect(() => {
        const onChange = (next: SubscriptionReturnStatus) => setStatus(next ?? null)
        stateHandler.addListener(StateConstants.SUBSCRIPTION_RETURN_STATUS, onChange)
        return () => stateHandler.removeListener(StateConstants.SUBSCRIPTION_RETURN_STATUS, onChange)
    }, [stateHandler])

    useEffect(() => {
        if (status === "activated") fireFireworks()
    }, [status])

    if (!status) return null

    return (
        <div className={`subscription-return-notice is-${status}`} role="status" aria-live="polite">
            <span>{MESSAGES[status]}</span>
            {status !== "activating" && (
                <button
                    type="button"
                    className="subscription-return-notice-close"
                    aria-label="Dismiss"
                    onClick={() => stateHandler.set(StateConstants.SUBSCRIPTION_RETURN_STATUS, null)}
                >
                    ×
                </button>
            )}
        </div>
    )
}
